export const en = {
    more: 'Learn more',
    'not-meet-requirements': "Doesn't meet requirements",
    repeat: 'Try again',
    uploading: 'Uploading'
};
